import { ENVIRONMENT_CLASS, ENVIRONMENT_NUMBER } from "env";
import { appendSearchToUrl } from "utils/campaignParams";

/**
 * Builds the environment-aware URL for the public GIWL marketing/product page.
 *
 * GIWL applicants are sent back to the aaalife.com Guaranteed Issue Whole Life
 * page (rather than restarting the application) for retry/begin/CTA actions.
 * The subdomain varies per environment: `www` in prd, `devaaa0<n>` locally, and
 * `<class>aaa0<n>` for all other environments.
 */
export const getGIWLProductUrl = (): string => {
    let subdomain: string;
    if (ENVIRONMENT_CLASS === "prd") {
        subdomain = "www";
    } else if (ENVIRONMENT_CLASS === "loc") {
        subdomain = `devaaa0${ENVIRONMENT_NUMBER}`;
    } else {
        subdomain = `${ENVIRONMENT_CLASS}aaa0${ENVIRONMENT_NUMBER}`;
    }
    return `https://${subdomain}.aaalife.com/whole-life-insurance/guaranteed-issue-whole-life`;
};

/**
 * Sends the user away from an error/expiry card. GIWL applicants are routed to the
 * public GIWL product page; DTO/MLTA applicants go to `fallbackUrl`, or reload the
 * current page when no fallback is provided. When `campaignSearch` is provided
 * (a query string like "cc=059&sc=67&cmp=ABC"), it is appended to the destination
 * so campaign attribution survives the exit.
 */
export const redirectFromExitCard = (isGIWL: boolean, fallbackUrl?: string, campaignSearch?: string): void => {
    if (isGIWL) {
        window.location.href = appendSearchToUrl(getGIWLProductUrl(), campaignSearch);
    } else if (fallbackUrl) {
        window.location.href = appendSearchToUrl(fallbackUrl, campaignSearch);
    } else {
        window.location.reload();
    }
};
